// extracted by mini-css-extract-plugin
module.exports = {"t1wcwjz4":"t1wcwjz4","b10jic5f":"b10jic5f","sdfpwm8":"sdfpwm8"};